export default __webpack_public_path__ + "static/media/logoBody.0615af14.png";